import React from 'react';
import {View} from 'react-native';
import DimensionController from './dimensionController';
import {styles} from './styles';

export default function DimensionsRow({dimensions, onUpdate}) {
  const dimensionProps = ['default_length', 'default_width', 'default_height'];
  
  return (
    <View style={styles.dimensionsContainer}>
      <View style={styles.dimensionLabelContainer}>
        {dimensionProps.map(prop => (
          <DimensionController
            key={prop}
            initialValue={dimensions[prop]}
            onUpdate={(value) => onUpdate({...dimensions, [prop]: value})}
          />
        ))}
      </View>
    </View>
  );
}
